// extracted by mini-css-extract-plugin
export default {"wrap":"Io-z","logoContainer":"Jo-z","brandImg":"Ko-z","logoImg":"Lo-z","logoButton":"Mo-z"};